<template>
  <div class="introduce">
    <!-- 斑点图 -->
    <header id="header" class="animate__animated  animate__zoomIn  animate__slow">
      <img src="../assets/images/introduce.jpg" alt="">
    </header><!-- /header -->

    <!-- 内容部分 -->
    <article class="introduce-con ">
      <nav class="col-md-3 animate__animated animate__wobble animate__slow">
        <div>
          <h4 class="titleI">公司简介</h4>
          <hr class="hrs" />
          <p class="titleI">INRODUCTION</p>
        </div>

        <ul class="introduce-nav animate__animated animate__wobble animate__slow">
          <li @click="tabIndex(1)"><a :class="{'active':Index==1}">公司介绍</a></li>
          <hr class="hrs" />
          <li @click="tabIndex(2)"><a :class="{'active':Index==2}">企业文化</a></li>
          <hr class="hrs" />
          <li @click="tabIndex(3)"><a :class="{'active':Index==3}">发展理念</a></li>
          <hr class="hrs" />
          <li @click="tabIndex(4)"><a :class="{'active':Index==4}">企业风采</a></li>
        </ul>
      </nav>
      <aside class="col-md-9   " style="margin:50px 0">
        <div class="col-md-12 animate__animated animate__bounceInDown ">
          <h4 class=" col-md-4 text-left">{{tabCon}}</h4>
          <div class="col-md-8 text-right">
            <p>当前位置：首页 > 公司简介 > <span>{{tabCon}}</span></p>
          </div>
          <div class="line"></div>
        </div>
        <div class="col-md-12 text-content text-content animate__animated animate__slideInUp animate__slow">
          <br>
          <brief v-if="Index==1"></brief>
          <culture v-if="Index==2"></culture>
          <development-idea v-if="Index==3"></development-idea>
          <corporate-style v-if="Index==4"></corporate-style>
        </div>
      </aside>
    </article>

  </div>
</template>

<script>
import Culture from "./Introduce/culture.vue";
import Brief from "./Introduce/brief.vue";
import developmentIdea from "./Introduce/developmentIdea.vue";
import corporateStyle from "./Introduce/corporateStyle.vue";

export default {
  name: "Introduce",
  data() {
    return {
      Index: 1,
      tabCon: "公司介绍",
    };
  },
  components: {
    culture: Culture,
    brief: Brief,
    developmentIdea: developmentIdea,
    corporateStyle: corporateStyle,
  },
  methods: {
    tabIndex(index) {
      this.Index = index;
      if (index == 1) {
        this.tabCon = "公司介绍";
      } else if (index == 2) {
        this.tabCon = "企业文化";
      } else if (index == 3) {
        this.tabCon = "发展理念";
      } else {
        this.tabCon = "企业风采";
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.introduce {
}
.texts {
  position: relative;
  line-height: 1.4em;
  /* 3 times the line-height to show 3 lines */
  height: 4.2em;
  overflow: hidden;
}
.texts::after {
  content: "";
  font-weight: bold;
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 0 20px 1px 45px;
  background: url(http://newimg88.b0.upaiyun.com/newimg88/2014/09/ellipsis_bg.png)
    repeat-y;
}
a {
  text-decoration: none;
  color: #333;
}
a:hover {
  text-decoration: none;
  color: #333;
  cursor: pointer;
}
/* 头部斑点图 */
#header img {
  width: 100%;
  height: 150px;
}

/*内容部分*/
.line {
  width: 97%;
  height: 1px;
  background-color: #ededed;
  display: block;
  margin-top: 46px;
}
.hrs {
  width: 80%;
  margin: 0 auto;
  height: 1px;
  border: 0;
  margin-bottom: 4px;
}
.introduce-con {
  width: 60%;
  margin: 20px auto;
}
.introduce-con nav {
  background-color: #ffffff;
  margin: 0;
  padding: 0;
  position: relative;
  top: -80px;
  box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.1);
}
.introduce-con nav ul {
  line-height: 40px;
}
.introduce-con nav div {
  background: #162987;
  color: #ffffff;
  text-align: left;
  padding: 10px 0;
}
.introduce-con .titleI {
  margin-left: 10%;
}
.introduce-con nav div hr {
  background-color: #2b3f96;
}
.introduce-nav hr {
  background-color: #ededed;
}
.introduce-nav .active {
  color: #162987;
}
/*内容*/
.text-left {
  padding: 0;
  margin-bottom: 20px;
  vertical-align: middle;
  padding-left: 6px;
}
.text-right p {
  margin-top: 12px;
  padding: 0;
  font-size: 12px;
  color: #b7b7b7;
}
.text-right p span {
  color: #414141;
}
</style>



// WEBPACK FOOTER //
// src/components/Introduce.vue